import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import KeyboardArrowLeftRoundedIcon from "@mui/icons-material/KeyboardArrowLeftRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import AssignmentTurnedInRoundedIcon from "@mui/icons-material/AssignmentTurnedInRounded";
import PolicyRoundedIcon from '@mui/icons-material/PolicyRounded';
import PeopleOutlineRoundedIcon from "@mui/icons-material/PeopleOutlineRounded";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import CorporateFareRoundedIcon from "@mui/icons-material/CorporateFareRounded";
import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import TranslateRoundedIcon from "@mui/icons-material/TranslateRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import PlaylistRemoveRoundedIcon from "@mui/icons-material/PlaylistRemoveRounded";
import CodeRoundedIcon from "@mui/icons-material/CodeRounded";
import DataObjectRoundedIcon from "@mui/icons-material/DataObjectRounded";
import KeyRoundedIcon from "@mui/icons-material/KeyRounded";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import MoveDownRoundedIcon from "@mui/icons-material/MoveDownRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import ArrowRightAltRoundedIcon from "@mui/icons-material/ArrowRightAltRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import TabUnselectedRoundedIcon from "@mui/icons-material/TabUnselectedRounded";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import BatteryChargingFullRoundedIcon from "@mui/icons-material/BatteryChargingFullRounded";
import BatteryCharging80RoundedIcon from "@mui/icons-material/BatteryCharging80Rounded";
import NumbersOutlinedIcon from "@mui/icons-material/NumbersOutlined";
import PlayCircleOutlineRoundedIcon from "@mui/icons-material/PlayCircleOutlineRounded";
import StopCircleOutlinedIcon from "@mui/icons-material/StopCircleOutlined";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import EngineeringRoundedIcon from "@mui/icons-material/EngineeringRounded";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import FileDownloadRoundedIcon from "@mui/icons-material/FileDownloadRounded";
import OpenInFullRoundedIcon from "@mui/icons-material/OpenInFullRounded";
import CloseFullscreenRoundedIcon from "@mui/icons-material/CloseFullscreenRounded";
import LaunchRoundedIcon from "@mui/icons-material/LaunchRounded";
import PermScanWifiRoundedIcon from "@mui/icons-material/PermScanWifiRounded";
import WifiRoundedIcon from "@mui/icons-material/WifiRounded";
import WifiOffRoundedIcon from "@mui/icons-material/WifiOffRounded";
import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import ContactPhoneRoundedIcon from "@mui/icons-material/ContactPhoneRounded";
import FilterAltRoundedIcon from "@mui/icons-material/FilterAltRounded";
import FilterAltOffRoundedIcon from "@mui/icons-material/FilterAltOffRounded";
import MarkEmailReadRoundedIcon from "@mui/icons-material/MarkEmailReadRounded";
import UnsubscribeRoundedIcon from "@mui/icons-material/UnsubscribeRounded";
import SystemSecurityUpdateGoodRoundedIcon from "@mui/icons-material/SystemSecurityUpdateGoodRounded";
import NoCellRoundedIcon from "@mui/icons-material/NoCellRounded";
import SummarizeRoundedIcon from "@mui/icons-material/SummarizeRounded";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import SupportAgentRoundedIcon from "@mui/icons-material/SupportAgentRounded";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import LocalPhoneRoundedIcon from "@mui/icons-material/LocalPhoneRounded";
import PublishedWithChangesRoundedIcon from "@mui/icons-material/PublishedWithChangesRounded";
import SyncProblemRoundedIcon from "@mui/icons-material/SyncProblemRounded";
import CloudSyncRoundedIcon from "@mui/icons-material/CloudSyncRounded";
import LanguageIcon from "@mui/icons-material/Language";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import HashtagIcon from "@mui/icons-material/Tag";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import PictureInPictureAltIcon from "@mui/icons-material/PictureInPictureAlt";
import Battery0BarIcon from "@mui/icons-material/Battery0Bar";
import Battery1BarIcon from "@mui/icons-material/Battery1Bar";
import Battery2BarIcon from "@mui/icons-material/Battery2Bar";
import Battery3BarIcon from "@mui/icons-material/Battery3Bar";
import Battery4BarIcon from "@mui/icons-material/Battery4Bar";
import Battery5BarIcon from "@mui/icons-material/Battery5Bar";
import Battery6BarIcon from "@mui/icons-material/Battery6Bar";
import BatteryFullIcon from "@mui/icons-material/BatteryFull";
import BatteryUnknownIcon from "@mui/icons-material/BatteryUnknown";
import ModeStandbyRoundedIcon from "@mui/icons-material/ModeStandbyRounded";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import BuildCircleOutlinedIcon from "@mui/icons-material/BuildCircleOutlined";
import TrendingUpRoundedIcon from "@mui/icons-material/TrendingUpRounded";
import TableRowsOutlinedIcon from "@mui/icons-material/TableRowsOutlined";
import WindowIcon from "@mui/icons-material/Window";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import BatteryChargingFullOutlinedIcon from "@mui/icons-material/BatteryChargingFullOutlined";
import BatteryCharging90OutlinedIcon from "@mui/icons-material/BatteryCharging90Outlined";
import BatteryCharging80OutlinedIcon from "@mui/icons-material/BatteryCharging80Outlined";
import BatteryCharging60OutlinedIcon from "@mui/icons-material/BatteryCharging60Outlined";
import BatteryCharging50OutlinedIcon from "@mui/icons-material/BatteryCharging50Outlined";
import BatteryCharging30OutlinedIcon from "@mui/icons-material/BatteryCharging30Outlined";
import BatteryCharging20OutlinedIcon from "@mui/icons-material/BatteryCharging20Outlined";
import RouterRoundedIcon from "@mui/icons-material/RouterRounded";
import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded";
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import AddAlertOutlinedIcon from "@mui/icons-material/AddAlertOutlined";
import EventRepeatRoundedIcon from "@mui/icons-material/EventRepeatRounded";
import ReplayRoundedIcon from "@mui/icons-material/ReplayRounded";
import MuiSettingsIcon from "@mui/icons-material/Settings";
import TerminalRoundedIcon from "@mui/icons-material/TerminalRounded";
import BuildRoundedIcon from "@mui/icons-material/BuildRounded";
import PauseRoundedIcon from "@mui/icons-material/PauseRounded";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import JoinFullRoundedIcon from "@mui/icons-material/JoinFullRounded";
import RateReviewRoundedIcon from "@mui/icons-material/RateReviewRounded";
import FitScreenRoundedIcon from "@mui/icons-material/FitScreenRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import Map from "@mui/icons-material/Map";
import TodayRoundedIcon from "@mui/icons-material/TodayRounded";
import AccountTreeRoundedIcon from "@mui/icons-material/AccountTreeRounded";
import BoltIcon from "@mui/icons-material/Bolt";
import DoneIcon from "@mui/icons-material/Done";
import AvTimerIcon from "@mui/icons-material/AvTimer";
import DateRangeIcon from "@mui/icons-material/DateRange";import DisplaySettingsRoundedIcon from "@mui/icons-material/DisplaySettingsRounded";
import Undo from "@mui/icons-material/Undo";
import Redo from "@mui/icons-material/Redo";
import Restore from "@mui/icons-material/Restore";
import Layers from "@mui/icons-material/Layers";
import PinDrop from "@mui/icons-material/PinDrop";
import PanTool from "@mui/icons-material/PanTool";
import Cancel from "@mui/icons-material/Cancel";
import HighlightOff from "@mui/icons-material/HighlightOff";
import Grid3x3 from "@mui/icons-material/Grid3x3";
import Crop from "@mui/icons-material/Crop";
import EditRoad from "@mui/icons-material/EditRoad";
import ZoomInMapRounded from "@mui/icons-material/ZoomInMapRounded";
import RuleIcon from '@mui/icons-material/Rule';
import CropFree from "@mui/icons-material/CropFree";
import FlagIcon from "@mui/icons-material/Flag";
import UploadRounded from "@mui/icons-material/UploadRounded";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import PublicRoundedIcon from "@mui/icons-material/PublicRounded";
import UpcomingRoundedIcon from "@mui/icons-material/UpcomingRounded";
import DialpadRoundedIcon from "@mui/icons-material/DialpadRounded";
import BugReportIcon from "@mui/icons-material/BugReport";
import LabelIcon from "@mui/icons-material/Label";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";

import TextFieldsRoundedIcon from "@mui/icons-material/TextFieldsRounded";
import DonutLargeRoundedIcon from "@mui/icons-material/DonutLargeRounded";
import StackedLineChartRoundedIcon from "@mui/icons-material/StackedLineChartRounded";
import TimelineRoundedIcon from "@mui/icons-material/TimelineRounded";
import EqualizerRoundedIcon from "@mui/icons-material/EqualizerRounded";
import TableChartRoundedIcon from "@mui/icons-material/TableChartRounded";
import MoneyRoundedIcon from "@mui/icons-material/MoneyRounded";
import FilterListRoundedIcon from "@mui/icons-material/FilterListRounded";
import FunctionsIcon from "@mui/icons-material/Functions";
import ToggleOffOutlinedIcon from "@mui/icons-material/ToggleOffOutlined";
import PrivacyTipRoundedIcon from "@mui/icons-material/PrivacyTipRounded";
import RobotSvgIcon from "./RobotIcon";
import ControlCameraRoundedIcon from '@mui/icons-material/ControlCameraRounded';
import { withStyles } from "tss-react/mui";

export const TextIcon = TextFieldsRoundedIcon;
export const PieChartIcon = DonutLargeRoundedIcon;
export const LineChartIcon = StackedLineChartRoundedIcon;
export const CumulativeChartIcon = TimelineRoundedIcon;
export const BarChartIcon = EqualizerRoundedIcon;
export const TableChartIcon = TableChartRoundedIcon;
export const CardIcon = MoneyRoundedIcon;
export const ResizeIcon = FilterListRoundedIcon;
export const OperationsIcon = FunctionsIcon;
export const DatasetConfigIcon = DisplaySettingsRoundedIcon;
export const BoolIcon = ToggleOffOutlinedIcon;

export const EmailIcon = EmailRoundedIcon;
export const PasswordIcon = LockRoundedIcon;
export const ShowInputIcon = VisibilityRoundedIcon;
export const HideInputIcon = VisibilityOffRoundedIcon;
export const ShowMoreIcon = MoreHorizIcon;

export const MaxTimeIcon = AvTimerIcon;
export const WeekTimeIcon = DateRangeIcon;
export const FilterTimeIcon = CleaningServicesIcon;

export const OpenIcon = KeyboardArrowRightRoundedIcon;
export const CloseIcon = KeyboardArrowLeftRoundedIcon;
export const DownArrow = KeyboardArrowDownRoundedIcon;
export const CollapseDownArrow = ArrowDropDownRoundedIcon;
export const FirstPageArrow = FirstPageIcon;
export const LastPageArrow = LastPageIcon;
export const CrossCloseIcon = CloseRoundedIcon;
export const RobotIcon = RobotSvgIcon;
export const DashboardIcon = SpaceDashboardIcon;
export const MissionsIcon = AssignmentOutlinedIcon;
export const MissionHistoryIcon = AssignmentTurnedInRoundedIcon;
export const TermsAndPrivacyIcon = PolicyRoundedIcon;
export const UsersIcon = PeopleOutlineRoundedIcon;
export const UserIcon = PersonOutlineRoundedIcon;
export const OrganizationsIcon = CorporateFareRoundedIcon;
export const LocationsIcon = LocationOnRoundedIcon;
export const SearchIcon = SearchRoundedIcon;
export const AdministrationIcon = EngineeringRoundedIcon;
export const DeploymentEndedIcon = ExitToAppIcon;
export const ApiEndpointsIcon = HashtagIcon;

export const SettingsIcon = MuiSettingsIcon;
export const SoftwareIcon = TerminalRoundedIcon;
export const HardwareIcon = BuildRoundedIcon;

export const ChangeLanguageIcon = TranslateRoundedIcon;
export const LogoutIcon = LogoutRoundedIcon;

export const AddIcon = AddRoundedIcon;
export const MinusIcon = RemoveRoundedIcon;
export const SaveIcon = SaveRoundedIcon;
export const InfoIcon = InfoRoundedIcon;
export const PrivacyIcon = PrivacyTipRoundedIcon;
export const EditIcon = EditRoundedIcon;
export const EventRepeatIcon = EventRepeatRoundedIcon;

export const ListIcon = MenuRoundedIcon;
export const CloseListIcon = PlaylistRemoveRoundedIcon;

export const CloudTokenIcon = CodeRoundedIcon;
export const ApiKeysIcon = DataObjectRoundedIcon;
export const KeyIcon = KeyRoundedIcon;
export const CopyIcon = ContentCopyRoundedIcon;
export const TransferIcon = MoveDownRoundedIcon;
export const MoveRightArrow = ArrowRightAltRoundedIcon;
export const DeleteIcon = DeleteOutlineRoundedIcon;
export const StatisticsIcon = BarChartRoundedIcon;
export const QueryStatisticsIcon = QueryStatsRoundedIcon;

export const SuccessIcon = CheckCircleOutlineRoundedIcon;
export const FailedIcon = HighlightOffRoundedIcon;
export const DurationIcon = TimerOutlinedIcon;
export const CleanedAreaIcon = TabUnselectedRoundedIcon;
export const TimeIcon = AccessTimeRoundedIcon;
export const BatteryStartIcon = BatteryChargingFullRoundedIcon;
export const BatteryEndIcon = BatteryCharging80RoundedIcon;
export const SerialNumberIcon = NumbersOutlinedIcon;
export const StartReasonIcon = PlayCircleOutlineRoundedIcon;
export const StopReasonIcon = StopCircleOutlinedIcon;
export const PerformanceIcon = AssessmentOutlinedIcon;
export const RoomIcon = PictureInPictureAltIcon;
export const OwnerIcon = SupervisedUserCircleIcon;
export const UploadIcon = UploadFileRoundedIcon;
export const DownloadIcon = FileDownloadRoundedIcon;
export const OpenDemoIcon = PlayCircleOutlineRoundedIcon;
export const PreviewIcon = VisibilityRoundedIcon;
export const EnableDrag = ControlCameraRoundedIcon;

export const OpenFullScreenIcon = OpenInFullRoundedIcon;
export const CloseFullScreenIcon = CloseFullscreenRoundedIcon;
export const OpenLinkIcon = LaunchRoundedIcon;

export const WebsocketDisconnectedIcon = PermScanWifiRoundedIcon;
export const ConnectedIcon = WifiRoundedIcon;
export const DisconnectedIcon = WifiOffRoundedIcon;
export const CostCalculationIcon = CalculateOutlinedIcon;
export const ContactPersonsIcon = ContactPhoneRoundedIcon;

export const FilterIcon = FilterAltRoundedIcon;
export const CloseFilterIcon = FilterAltOffRoundedIcon;

export const EmailNotificationsEnabled = MarkEmailReadRoundedIcon;
export const EmailNotificationsDisabled = UnsubscribeRoundedIcon;
export const DevicePushNotificationsEnabled = SystemSecurityUpdateGoodRoundedIcon;
export const DevicePushNotificationsDisabled = NoCellRoundedIcon;
export const NotificationIcon = NotificationsRoundedIcon;
export const SummaryIcon = SummarizeRoundedIcon;
export const CustomTuneFiltersIcon = TuneRoundedIcon;
export const SupportDudeIcon = SupportAgentRoundedIcon;
export const AcademyIcon = MenuBookOutlinedIcon;
export const FeedbackIcon = RateReviewRoundedIcon;
export const PhoneIcon = LocalPhoneRoundedIcon;
export const MenuIcon = MenuRoundedIcon;
export const RoleIcon = PublishedWithChangesRoundedIcon;
export const SyncErrorIcon = SyncProblemRoundedIcon;
export const SyncIcon = CloudSyncRoundedIcon;
export const TimezoneIcon = LanguageIcon;

export const TableIcon = TableRowsOutlinedIcon;
export const GridIcon = WindowIcon;

export const StandbyIcon = ModeStandbyRoundedIcon;
export const ErrorIcon = ErrorOutlineIcon;
export const MaintenanceIcon = BuildCircleOutlinedIcon;
export const CleaningIcon = TrendingUpRoundedIcon;
export const UnknownIcon = HelpOutlineIcon;
export const ServiceConnectionIcon = RouterRoundedIcon;

export const NotSubscribedIcon = AddAlertOutlinedIcon;
export const SubscribedIcon = NotificationsRoundedIcon;
export const RefreshIcon = ReplayRoundedIcon;

export const PauseIcon = PauseRoundedIcon;
export const PlayIcon = PlayArrowRoundedIcon;
export const MergeIcon = JoinFullRoundedIcon;
export const VersionIcon = BuildCircleOutlinedIcon;

export const FitToPageIcon = FitScreenRoundedIcon;
export const OpenInNewTabIcon = OpenInNewRoundedIcon;

export const MapIcon = Map;
export const SchedulerIcon = TodayRoundedIcon;
export const MapConfigurationIcon = TuneRoundedIcon;
export const RoomOverviewIcon = AccountTreeRoundedIcon;

export const UndoIcon = Undo;
export const RedoIcon = Redo;
export const RestoreIcon = Restore;
export const LayersListIcon = Layers;
export const WaypointIcon = PinDrop;
export const DragIcon = PanTool;
export const CancelIcon = Cancel;
export const DeletePointIcon = HighlightOff;
export const MapGridIcon = Grid3x3;
export const CropIcon = Crop;
export const EditMapIcon = EditRoad;
export const EvacuationIcon = ZoomInMapRounded;
export const MapRulesIcon = RuleIcon;
export const LimitZoneIcon = CropFree;
export const LandmarkIcon = FlagIcon;
export const RotateIcon = RotateLeftIcon;

export const EnvironmentIcon = PublicRoundedIcon;
export const RobotVisibilityIcon = UpcomingRoundedIcon;
export const NavigatorSettingsIcon = FitScreenRoundedIcon;
export const ButtonsIcon = DialpadRoundedIcon;

export const InheritIcon = MoveDownRoundedIcon;
export const SupportTicketIcon = BugReportIcon;

export const CompleteIcon = DoneIcon;
export const TagIcon = LabelIcon;

export const getBatteryIconByPercentage = (percentage?: number, isCharging?: boolean) => {
  if (percentage == null) {
    return BatteryUnknownIcon;
  }
  if (percentage > 90) {
    if (isCharging) return BatteryChargingFullOutlinedIcon;
    return BatteryFullIcon;
  } else if (percentage > 80) {
    if (isCharging) return BatteryCharging90OutlinedIcon;
    return Battery6BarIcon;
  } else if (percentage > 65) {
    if (isCharging) return BatteryCharging80OutlinedIcon;
    return Battery5BarIcon;
  } else if (percentage > 50) {
    if (isCharging) return BatteryCharging60OutlinedIcon;
    return Battery4BarIcon;
  } else if (percentage > 35) {
    if (isCharging) return BatteryCharging50OutlinedIcon;
    return Battery3BarIcon;
  } else if (percentage > 20) {
    if (isCharging) return BatteryCharging30OutlinedIcon;
    return Battery2BarIcon;
  } else if (percentage > 10) {
    if (isCharging) return BatteryCharging20OutlinedIcon;
    return Battery1BarIcon;
  }
  if (isCharging) return BatteryCharging20OutlinedIcon;
  return Battery0BarIcon;
};

export const SendBelowIcon = withStyles(UploadRounded, {
  root: {
    transform: "rotate(180deg)",
  },
});

export const ChargingStationIcon = withStyles(BoltIcon, {
  root: {
    filter: "drop-shadow(0 0 1px #000000)",
    color: "#FFC400",
  },
});